/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Data Sources`)
};

const es_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Fuentes de datos`)
};

const de_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Datenquellen`)
};

const nl_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Gegevensbronnen`)
};

const fr_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Sources de données`)
};

const it_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Fonti dati`)
};

const pt_br2_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Fontes de dados`)
};

const pt_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Fontes de dados`)
};

const ja_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジー — データソース`)
};

const zh_about_section_data_sources = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1梦幻赛车 — 数据来源`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_section_data_sources = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_section_data_sources(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_section_data_sources", locale)
	if (locale === "en") return en_about_section_data_sources(inputs)
	if (locale === "es") return es_about_section_data_sources(inputs)
	if (locale === "de") return de_about_section_data_sources(inputs)
	if (locale === "nl") return nl_about_section_data_sources(inputs)
	if (locale === "fr") return fr_about_section_data_sources(inputs)
	if (locale === "it") return it_about_section_data_sources(inputs)
	if (locale === "pt-BR") return pt_br2_about_section_data_sources(inputs)
	if (locale === "pt") return pt_about_section_data_sources(inputs)
	if (locale === "ja") return ja_about_section_data_sources(inputs)
	return zh_about_section_data_sources(inputs)
};